import React from 'react';
import {
  ReportSection,
  ThumbRatingContainer,
  RestoreAllDataButton,
} from '@/reports/index';
import { peopleTypes } from '@/reports/types';
import { EducationCard } from './EducationCard';

export interface EducationProps {
  personName: string;
  educations: peopleTypes.Educations;
  permalink: string;
}

export function Education({
  personName,
  educations,
  permalink,
}: EducationProps) {
  return (
    <ReportSection
      title="Possible Education"
      sectionDescription={`Any educational institutions that ${personName} currently or previously attended, as well as any degrees conferred while there that are documented on publicly accessible sources are shown below:`}
      sectionId="education-section"
      hasContent={educations.length > 0}
      personName={personName}
    >
      {educations.map((education, index: number) => (
        // Index is being used as key of the iteration since it's essential a data fetch operation.
        // This array don't change after we fetch data. - RV October 2022
        <ThumbRatingContainer
          key={index}
          item={education}
          dataPropKey="education"
          permalink={permalink}
          component={EducationCard}
        />
      ))}
      <RestoreAllDataButton items={educations} permalink={permalink} />
    </ReportSection>
  );
}
